import smoothscroll from 'smoothscroll';

/**
 * "Back to top" — ported from the .in engine's @common/events/go-back-to-top.js,
 * without cash-dom. The button is #goBackToTop in layout.ejs.
 *
 * INP: the visibility class lives on the button itself, NOT on the body. A
 * class toggle on the body invalidates style for the whole document on every
 * threshold cross while scrolling; on the button it touches one element. The
 * listener is passive and only writes to the DOM when the 800px threshold is
 * actually crossed.
 */
export function goBackToTopButtonInit() {
  const btn = document.getElementById('goBackToTop');
  if (!btn) return;

  btn.addEventListener('click', () => {
    smoothscroll(0, 1200);
  });

  let shown = false;
  let ticking = false;
  window.addEventListener(
    'scroll',
    () => {
      if (ticking) return;
      ticking = true;
      setTimeout(() => {
        ticking = false;
        const shouldShow = window.scrollY >= 800;
        if (shouldShow !== shown) {
          shown = shouldShow;
          btn.classList.toggle('show-backtotop', shown);
        }
      }, 35);
    },
    { passive: true },
  );
}
